<template>
  <div>
    <div class="blue-subhead-bg text-uppercase">
      <h1>Edit Loyalty Program</h1>
    </div>

    <div class="container admin-users">
      <h1 class="text-center text-uppercase">{{program.name}}</h1>
      <br>

      <div class="users-list" v-if="!currentUser">
        <div
          class="blue-outline-nh"
          v-for="(user) in users" :key="user._id"
        >
          <div class="row">
            <div class="col-sm-4">{{ user.name }}</div>
            <div class="col-sm-4"><a href="" class="admin-clickable" @click.prevent="goUserDetails(user)"><strong>View</strong></a></div>
            <div class="col-sm-4 text-right">
              <a href="" class="admin-clickable" @click.prevent="disable(user.userLoyaltyProgram._id)"><strong>Disable</strong></a>
            </div>
          </div>
        </div>
        <br>
        <router-link :to="{name: 'EditLoyaltyProgram'}" class="btn btn-lg admin-btn-primary col-md-2 col-md-offset-10">Back</router-link>
        <div class="clearfix"></div>
        <br>
      </div>

      <div class="user-details" v-else>
        <div class="row">
          <div class="col-sm-12">
            <strong>Users</strong>
          </div>
        </div>

        <div class="blue-outline-nh light-grey-type">
          <div class="row">
            <div class="col-sm-12">
              <h4>Standard Fields</h4>
              Name: {{ currentUser.name }}<br>
              Username: {{ currentUser.username }}<br>
              Email: {{ currentUser.email }}<br>
              Address: {{ currentUser.address }}<br>
              City: {{ currentUser.city }}<br>
              State: {{ currentUser.state }}<br>
              Zip: {{ currentUser.zip }}<br>
              <div v-if="program.registrationForm.formItems.length > 0">
                <h4>Program Specific Fields</h4>
                <span v-for="(formItem, index) in program.registrationForm.formItems" :key="index">
                  <!-- TODO: CHECK FOR SELECT FIELD (MULTIPLE ANSWERS) -->
                  {{ formItem.label }}: {{ currentUser.userLoyaltyProgram.completedRegistration[formItem.uid] }}<br>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <a href="" class="admin-clickable" @click.prevent="currentUser = null"><strong>Back</strong></a> |
            <a href="" class="admin-clickable" @click.prevent="disable(currentUser.userLoyaltyProgram._id)"><strong>Disable</strong></a>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ApprovedUsers',
  data () {
    return {
      currentUser: null
    }
  },
  computed: {
    ...mapState('loyaltyProgram', ['program']),
    ...mapState('user', [ 'users' ])
  },
  methods: {
    ...mapActions('user', [
      'updateUserLoyaltyProgram',
      'deleteUserById'
    ]),
    disable (id) {
      // add disable user method
      this.updateUserLoyaltyProgram({ id, userLoyaltyProgram: { disabled: true } })
        .then((response) => {
          this.$router.push({ name: 'EditLoyaltyProgram' })
        })
        .catch(err => {
          console.log(err)
        })
    },
    goUserDetails (user) {
      this.currentUser = user
    }
  }
}
</script>
